var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.81437 14.2501C4.81437 14.1076 4.86687 13.9651 4.97937 13.8526L15.4794 3.35258C15.6969 3.13508 16.0569 3.13508 16.2744 3.35258C16.4919 3.57008 16.4919 3.93008 16.2744 4.14758L5.77437 14.6476C5.55688 14.8651 5.19687 14.8651 4.97937 14.6476C4.86687 14.5351 4.81437 14.3926 4.81437 14.2501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.61 3.75C7.61 3.4425 7.865 3.1875 8.1725 3.1875L15.875 3.1875C16.1825 3.1875 16.4375 3.4425 16.4375 3.75V11.4525C16.4375 11.76 16.1825 12.015 15.875 12.015C15.5675 12.015 15.3125 11.76 15.3125 11.4525V4.3125H8.1725C7.865 4.3125 7.61 4.0575 7.61 3.75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send2.1ea682f5e611fede08d5c814d704821f.svg";
export { ForwardRef as ReactComponent };